import React from "react";
import { useTheme } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";

export const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        paddingBottom: "0.25rem",
        backgroundColor: theme.palette.primary.main,
        color: "white",
        height: { xs: "10vh", md: "20vh" },
      }}
    >
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12} sx={{ height: { xs: "6vh", md: "10vh" } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
              py: { xs: 0, md: 0 },
            }}
          >
            <h4>Contáctanos</h4>
            <Typography
              variant="body2"
              component="p"
              sx={{
                position: "absolute",
                right: 16,
                fontSize: { xs: "0.75rem", md: "0.875rem" },
              }}
            >
              v2.9.14
              {window.location.origin ===
              "https://logicsoft-app-testing.netlify.app"
                ? "-dev"
                : ""}
            </Typography>
          </Box>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="row"
          sx={{ height: { xs: "5vh", md: "10vh" } }}
        >
          <Box
            sx={{
              width: { xs: 24, md: 35 },
              mx: 2,
            }}
            className="scale-up-hover"
          >
            <a href="https://www.ls-sys.com">
              <img
                src="assets/globe.png"
                alt="Website"
                style={{ width: "100%" }}
              />
            </a>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: { xs: 40, md: 80 },
              height: { xs: 40, md: 80 },
              my: 1,
            }}
          >
            <img
              src="assets/LogicSoft.png"
              alt="LogicSoft Logo"
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
          <Box
            sx={{
              width: { xs: 28, md: 40 },
              mx: 2,
            }}
            className="scale-up-hover"
          >
            <a href="mailto:ventas@ls-sys.com">
              <img
                src="assets/email.png"
                alt="Email"
                style={{ width: "100%" }}
              />
            </a>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
